<template>
	<div id="teamSign">
		<div class="teamSign-editor">
			<span class="dasai ds_guanbi1" @click="downfun()"></span>
			<div class="teamSign_title">团队报名</div>
			<div class="teamSign_content">
				<p class="teamSign_sign">团队信息:</p>
				<p class="teamSign_input"><span>团队名称</span><el-input style='width: 300px;' v-model="form.TeamName" placeholder="请输入内容"></el-input></p>
				<p class="teamSign_input"><span>所在机构</span><el-input style='width: 300px;' v-model="form.TeamOrg" placeholder="请输入内容"></el-input></p>
				<p class="teamSign_sign" style="margin-top: 30px;">成员信息:</p>
				
				<div class="Members">
					<div class="Members_list" v-for="(item,index) of form.MemberMobiles">
						<p class="list"><span>{{index == 0?'队长':'成员'}}</span></p>
						<p class="list" v-if="index == 0"><span>手机号码</span><el-input style='width:190px;' disabled maxlength="11" @change="changePhone(index,item.phone)" v-model="item.phone" placeholder="请输入内容"></el-input></p>
						<p class="list" v-if="index != 0"><span>手机号码</span><el-input style='width:190px;' maxlength="11" @change="changePhone(index,item.phone)" v-model="item.phone" placeholder="请输入内容"></el-input></p>
						<p class="list"><span>名&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;称</span><el-input style='width: 190px;' v-model="names[index].name" disabled placeholder="请输入手机号获取"></el-input></p>
					</div>
				</div>
				
				<div class="sign_btn">
					<button @click="save()">报名</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return{
				input:'',
				down:0,
				form:{
					TeamName:'',
					TeamOrg:'',
					MemberMobiles:[{phone:''},{phone:''},{phone:''},{phone:''}]
				},
				names:[{name:''},{name:''},{name:''},{name:''}]
			}
		},
		created(){
			this.getmember()
		},
		methods:{
			downfun(){
				this.$emit('downfun',this.down)
			},
			getmember(){
				this.axios.get('/api/member/GetMember')
				.then(res => {
						console.log(res)
						this.form.MemberMobiles[0].phone = res.data.data.Mobile
						this.changePhone(0,res.data.data.Mobile)
				})
				.catch(error => {
				  console.log(error)
				})
			},
			changePhone(index,value){
				console.log(index,value)
				for(let x in this.form.MemberMobiles){
					console.log(this.form.MemberMobiles)
					if(index == x ){
						
					}else{
						if(this.form.MemberMobiles[x].phone == value){
							this.$message({
							  message: '手机号不能重复',
							  type: 'error'
							});
							this.form.MemberMobiles[index].phone ==''
						}
						
					}
					
				}
				this.axios.get('/api/member/GetUserByMobile?mobile='+value)
				.then(res => {
						console.log(res)
						if(res.data.Success){
							this.names[index].name = res.data.data.UserName
						}else{
							this.$message({
							  message: res.data.ErrorMsg,
							  type: 'error'
							});
						}
						
				})
				.catch(error => {
				  console.log(error)
				})
			},
			save(){
				console.log(this.form)
				this.axios.post('/api/team/CreatTeam',this.form)
				.then(res => {
						console.log(res)
						if(res.data.Success){
							this.$message({
							  message: '报名成功，请前往个人中心进行线上学习或答题！',
							  type: 'success'
							});
							this.$router.push('/myteam')
							var competition_info = JSON.parse(localStorage.getItem('competition_info'))
							competition_info.RegistType = 1
							localStorage.setItem("competition_info",JSON.stringify(competition_info))
						}else{
							this.$message({
							  message: res.data.ErrorMsg,
							  type: 'error'
							});
						}
						
				})
				.catch(error => {
				  console.log(error)
				})
			}
		}
	}
</script>

<style scoped="scoped" lang="scss">
	#teamSign {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
		color: #333;
		z-index: 1;
		.ds_guanbi1{
			position: absolute;
			top: 18px;right: 20px;color: #fff;
		}
		.teamSign-editor {
			overflow: scroll;width: 700px;height: 600px;background: #fff;position: absolute;top: 0;left: 0;bottom: 0;right: 0;margin: auto;border-radius: 5px;.teamSign_title{text-align: center;height: 50px;line-height: 50px;background: #3e1976;color: #fff;font-size: 16px;}
			.teamSign_content{
				height: 550px;
				padding: 30px 20px;
				box-sizing: border-box;
				.teamSign_sign{
					font-size:18px;
				}
				.teamSign_input{
					font-size: 14px;
					margin-top: 20px;
					span{margin-right: 20px}
				}
				.Members{
					overflow: hidden;
					.Members_list{
						float: left;width: 50%;
						margin-top: 20px;
						.list{
							display: flex;font-size: 14px;
							margin-top: 10px;
							align-items: center;margin-right: 10px;
							span{
								// width: 80px;
								white-space: nowrap;
								margin-right: 20px;
							}
						}
					}
				}
				.sign_btn{
					width: 100%;
					text-align: center;
					margin-top: 40px;
					button{
						padding: 5px 100px;
						background: linear-gradient(to left,#3e1976,#70579f);
						color: #fff;
						font-size: 16px;
						border-radius: 30px;
					}
					
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/teamSign.vue